import script from "./ResultatsImpactsv2.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultatsImpactsv2.vue?vue&type=script&setup=true&lang=js"

import "./ResultatsImpactsv2.vue?vue&type=style&index=0&id=ead82492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ead82492"]])

export default __exports__